<template>
    <SwipeModalComponent v-if="homeMenu.isVisible" @closeMenu="changeHomeMenuVisibility">
        <div class="content-wrapper">
            <h2 v-text="getUserName"></h2>

            <div class="menu-itens-container">
                <div class="menu-itens" v-for="(item, hmikey) in homeMenu.itens" :key="hmikey" @click="emitEvent(item)">
                    <!-- <i :class="`fa fas ${item.icon}`"></i> -->
                    <fa :icon="['fas', item.icon]" class="icon" />
                    <h3 v-text="item.name"></h3>
                    <span>
                      <fa :icon="['fas', 'chevron-right']" />
                    </span>
                </div>
            </div>
            <div class="footer-item-container">
                <div class="footer-item" v-for="(item, hmikey) in homeMenu.footerItens" :key="hmikey" @click="emitEvent(item)">
                    <!-- <i :class="`fa fas ${item.icon}`"></i> -->
                    <fa :icon="['fas', item.icon]" class="icon" />
                    <h3 v-text="item.name"></h3>
                </div>
            </div>
        </div>
        <PoweredBy></PoweredBy>
    </SwipeModalComponent>
</template>
<script >
import SwipeModalComponent from '@/components/bottom-popups/SwipeModalComponent.vue'
import PoweredBy from '@/components/PoweredBy.vue'
import { mapGetters, mapActions } from 'vuex'
import Util from '@/assets/libs/util'

export default {
  name: 'HomeMenuComponent',
  emits: ['componentEvent'],
  components: {
    SwipeModalComponent,
    PoweredBy
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['homeMenu', 'retailGeneralParams', 'getUserName'])
  },
  methods: {
    ...mapActions(['changeHomeMenuVisibility']),
    emitEvent: function (item) {
      this.changeHomeMenuVisibility()

      if (item.external) {
        return Util.callWppHelp()
      }
      this.$emit('componentEvent', item)
    }
  }
}
</script>
<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;
    margin-bottom: 50px;

    h2 {
        text-align: center;
        font-size: 1em;
        margin-bottom: 20px;
    }
    .menu-itens-container {
        padding: 0 15px;
        height: calc(calc(100% - 30%) - 45px);
        overflow: auto;
        .menu-itens {
            position: relative;
            display: grid;
            grid-template-columns: 30px calc(100% - 60px) 30px;
            border-bottom: solid #BAB8B8 2px;
            padding: 0 0 20px 0;
            margin-bottom: 20px;
            span {
                color: var(--primaryColor);
                text-align: right;
            }
            h3 {
                font-size: 1em;
                font-weight: normal;
            }
            .icon, h3, span {
                margin: auto 0;
            }
        }
    }
    .footer-item-container {
        position: relative;
        left: 15px;
        height: 45px;
        display: block;
        margin-top: 20px;
        .icon {
            color: var(--primaryColor);
            margin-right: 15px;
        }

        h3 {
            font-size: 1em;
            font-weight: 600;
        }

        .icon, h3{
            display: inline-block;
        }
    }
}
</style>
